const PlaceHolder = () => {
    return 'PlaceHolder'
}

export default PlaceHolder
